import { render } from "./FormCodeEditor.vue?vue&type=template&id=feb3e2f6&scoped=true"
import script from "./FormCodeEditor.vue?vue&type=script&lang=js"
export * from "./FormCodeEditor.vue?vue&type=script&lang=js"

import "./FormCodeEditor.vue?vue&type=style&index=0&id=feb3e2f6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feb3e2f6"]])

export default __exports__